import { z } from "zod";
const surveyScales = [
  "important_unimportant",
  "agree_disagree",
  "satisfied_dissatisfied",
  "yes_no"
];
function isSurveyScale(value) {
  return surveyScales.includes(value);
}
const QuestionsImportSource = {
  LIST_OF_QUESTIONS: "list_of_questions",
  RESEARCH_DISCUSSION_GUIDE: "research_discussion_guide",
  JOB_DESCRIPTION: "job_description"
};
const allQuestionsImportSources = [
  QuestionsImportSource.LIST_OF_QUESTIONS,
  QuestionsImportSource.RESEARCH_DISCUSSION_GUIDE,
  QuestionsImportSource.JOB_DESCRIPTION
];
const questionsImportSourceSchema = z.enum(allQuestionsImportSources);
const complexQuestionTypes = ["rating", "multiple_choice"];
const mapComplexQuestionDbToComplexQuestion = (questionDb) => {
  if (questionDb.type === "rating")
    return {
      id: questionDb.id,
      company_id: questionDb.company_id,
      project_id: questionDb.project_id,
      question: questionDb.question,
      type: questionDb.type,
      options: questionDb.options,
      scale: questionDb.scale
    };
  else if (questionDb.type === "multiple_choice")
    return {
      id: questionDb.id,
      company_id: questionDb.company_id,
      project_id: questionDb.project_id,
      question: questionDb.question,
      type: questionDb.type,
      options: questionDb.options
    };
  throw new Error(`Unknown question type: ${questionDb.type}`);
};
function isComplexQuestionType(value) {
  return complexQuestionTypes.includes(value);
}
export {
  QuestionsImportSource,
  allQuestionsImportSources,
  isComplexQuestionType,
  isSurveyScale,
  mapComplexQuestionDbToComplexQuestion,
  questionsImportSourceSchema,
  surveyScales
};
//# sourceMappingURL=question.js.map
